import { Outlet } from "react-router-dom";
import { Box, Stack, styled, Typography } from "@mui/material";
import EnvToggle from "./_components/env-toggle";
import SandboxBanner from "./_components/sandbox-banner";

const RootWrapper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const LedgerOutlet = () => {
  return (
    <RootWrapper>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Ledger
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage double-entry accounts and post balanced journals across
            environments.
          </Typography>
        </Box>
        <EnvToggle />
      </Stack>

      <SandboxBanner />

      <Outlet />
    </RootWrapper>
  );
};

export default LedgerOutlet;
